import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "scmp-app/components/article/article-render";
import type { articleBeforeYouGoWidget$key } from "scmp-app/queries/__generated__/articleBeforeYouGoWidget.graphql";

import { ArticleBeforeYouGoTopics } from "./article-before-you-go-topics";
import { Container, Divider, StyledBeforeYouGoActionWidgets, Title } from "./styles";

type Props = {
  children?: ReactNode;
  className?: string;
  provider: DefaultComponentsProvider;
  reference: articleBeforeYouGoWidget$key;
};

export const ArticleBeforeYouGoWidget: FunctionComponent<Props> = ({
  children,
  className,
  provider,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment articleBeforeYouGoWidget on Content {
        ...articleBeforeYouGoTopicsContent
        ...beforeYouGoActionWidgetContent
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <Title>Before you go</Title>
      {provider.commentTriggerAndReaction({ variant: "article-2.0-banner" }, { isEnabled: false })}
      <StyledBeforeYouGoActionWidgets provider={provider} reference={article} />
      <Divider />
      {children && (
        <>
          {children}
          <Divider />
        </>
      )}
      <ArticleBeforeYouGoTopics reference={article} />
    </Container>
  );
};

ArticleBeforeYouGoWidget.displayName = "ArticleBeforeYouGoWidget";
